import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import CurrencyUsdIcon from 'mdi-react/CurrencyUsdIcon';
import renderCheckBoxField from '../../../../shared/components/form/CheckBox';
import { renderFieldForm } from '../../shared/formComponents';
import { UNIFIED_SUB_DETAIL_OPTIONS } from '../../shared/constants';

/**
 * Unified (Amazon, Budget Type = Item) sub-type budgets.
 *
 * Each sub-type has a checkbox and a Daily Budget Amount (single item, tied to a campaign).
 * Checked rows are sent as budget_group_daily_sub_details: [{ configuration_key, budget }].
 * Unchecked rows are simply not sent.
 *
 * NOTE: The shared CheckBox calls onChange(defaultChecked) on mount, so we pass the current
 * form value as defaultChecked to keep saved/edited values.
 */
const UnifiedSubDetailsFields = ({ formValues, cleanNumber, currencyCode }) => (
  <div className="form__form-group">
    <span className="form__form-group-label">Sub-Type Daily Budgets ({currencyCode})</span>
    {!UNIFIED_SUB_DETAIL_OPTIONS.some(option => formValues?.[option.checkField]) && (
      <span className="form__form-group-error" style={{ display: 'block', marginBottom: '8px' }}>
        Select at least one sub-type and enter its Budget Amount.
      </span>
    )}
    {UNIFIED_SUB_DETAIL_OPTIONS.map((option) => {
      const isChecked = !!formValues?.[option.checkField];
      return (
        <div key={option.value} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <Field
              name={option.checkField}
              component={renderCheckBoxField}
              label={option.label}
              defaultChecked={isChecked}
            />
          </div>
          <div className="form__form-group-field" style={{ width: '140px', flex: 'none' }}>
            <div className="form__form-group-icon">
              <CurrencyUsdIcon />
            </div>
            <Field
              name={option.amountField}
              type="text"
              component={renderFieldForm}
              format={cleanNumber}
              isDisabled={!isChecked}
            />
          </div>
        </div>
      );
    })}
  </div>
);

UnifiedSubDetailsFields.propTypes = {
  formValues: PropTypes.shape(),
  cleanNumber: PropTypes.func.isRequired,
  currencyCode: PropTypes.string,
};

UnifiedSubDetailsFields.defaultProps = {
  formValues: {},
  currencyCode: 'USD',
};

export default UnifiedSubDetailsFields;
